<template>
    <div id="app">

        <template v-if="this.isLeft">
            <template v-if="this.data.imageOverrides.left">
                <FullPageBackground :url="this.data.imageOverrides.left"/>
            </template>
            <template v-else>
                <WelcomePanel v-if="this.roomData.length <= 1"/>
                <WelcomePanel v-if="this.roomData.length === 2" with-clock :time="this.time"/>
                <SplitPage v-if="this.roomData.length === 3">
                    <ClockPanel slot="left" :time="this.time"/>
                    <Course slot="right" :data="this.roomData[0]"/>
                </SplitPage>
                <SplitPage v-if="this.roomData.length === 4">
                    <Course slot="left" :data="this.roomData[0]"/>
                    <Course slot="right" :data="this.roomData[1]"/>
                </SplitPage>
            </template>
        </template>

        <template v-if="this.isRight">
            <template v-if="this.data.imageOverrides.right">
                <FullPageBackground :url="this.data.imageOverrides.right"/>
            </template>
            <template v-else>
                <ClockPanel v-if="this.roomData.length === 0" :time="this.time"/>
                <SplitPage v-if="this.roomData.length === 1">
                    <ClockPanel slot="left" :time="this.time"/>
                    <Course slot="right" :data="this.roomData[0]"/>
                </SplitPage>
                <SplitPage v-if="this.roomData.length === 2">
                    <Course slot="left" :data="this.roomData[0]"/>
                    <Course slot="right" :data="this.roomData[1]"/>
                </SplitPage>
                <SplitPage v-if="this.roomData.length === 3">
                    <Course slot="left" :data="this.roomData[1]"/>
                    <Course slot="right" :data="this.roomData[2]"/>
                </SplitPage>
                <SplitPage v-if="this.roomData.length === 4">
                    <Course slot="left" :data="this.roomData[2]"/>
                    <Course slot="right" :data="this.roomData[3]"/>
                </SplitPage>
            </template>
        </template>

    </div>
</template>

<script>
import FullPageBackground from './FullPageBackground.vue';
import SplitPage from './SplitPage.vue';
import Course from './Course.vue';
import ClockPanel from './ClockPanel.vue';
import WelcomePanel from './WelcomePanel.vue';

export default {
    name: 'app',
    components: {FullPageBackground, SplitPage, Course, ClockPanel, WelcomePanel},
    data() {
        return {
            time: new Date(),
            data: {
                roomData: [],
                imageOverrides: {
                    left: null,
                    right: null,
                },
            },
        }
    },
    props: {
        monitor: {type: String, required: true},
        date: {type: String, required: true},
    },
    computed: {
        isLeft() {
            return this.monitor === 'left';
        },
        isRight() {
            return this.monitor === 'right';
        },
        roomData() {
            return this.data.roomData;
        },
    },
    mounted: function () {
        this.$options.timer = setInterval(() => this.time = new Date(), 1000);
        const updateData = () => axios.get(`/guidance/${this.monitor}/${this.date}`)
            .then(response => this.data = response.data);
        setInterval(updateData, 5000);
        updateData();
    },
    beforeDestroy: function () {
        clearInterval(this.$options.timer);
    },
}
</script>

<style>
@font-face {
    font-family: FamiljenGrotesk;
    font-weight: 400;
    src: url("/fonts/FamiljenGrotesk-Regular.woff2") format("woff2");
}

@font-face {
    font-family: FamiljenGrotesk;
    font-weight: 500;
    src: url("/fonts/FamiljenGrotesk-Medium.woff2") format("woff2");
}

@font-face {
    font-family: Inter;
    font-weight: 400;
    src: url("/fonts/Inter_18pt-Regular.ttf") format("truetype");
}

@font-face {
    font-family: Inter;
    font-weight: 500;
    src: url("/fonts/Inter_18pt-Medium.ttf") format("truetype");
}

@font-face {
    font-family: Inter;
    font-weight: 600;
    src: url("/fonts/Inter_18pt-SemiBold.ttf") format("truetype");
}

#app {
    font-family: Inter;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: #f5f5f5;
}

.wrapper {
    width: 100%;
    height: 100%;
}

.split .right > .courseComponent {
    border-left: 1px solid #aeaeae;
}
</style>
